import { render, staticRenderFns } from "./BrandTooltip.vue?vue&type=template&id=e2342600"
import script from "./BrandTooltip.vue?vue&type=script&lang=js"
export * from "./BrandTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports